(function() {
    'use strict';

    angular
        .module('elogbooks.user.service-providers.contracts')
        .config(registerRoutes);

    function registerRoutes($stateProvider) {
        elbContractsRouting().addRoutes($stateProvider, 'dashboard.user.service-providers.list.details.contracts', false);
    }
})();
